import type { SVGProps } from "react";
export interface DatabaseLockIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DatabaseLockIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DatabaseLockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 18.5v-13a1.125 1.125 0 0 1 2.25 0V12l.012.1c.025.114.1.275.3.481.271.28.718.583 1.356.863 1.275.557 3.115.931 5.206.931q.603 0 1.177-.04a1.126 1.126 0 0 1 .154 2.245q-.652.046-1.33.046c-2.327 0-4.487-.412-6.107-1.121a9 9 0 0 1-.768-.382V18.5c0 .112.047.306.312.58.271.28.718.585 1.356.865 1.275.558 3.115.93 5.206.93h.096l.115.004a1.125 1.125 0 0 1 .012 2.238l-.114.008h-.109c-2.326 0-4.486-.41-6.106-1.12-.809-.353-1.535-.803-2.073-1.36-.544-.562-.945-1.29-.945-2.145m16-8.406V5.5a1.125 1.125 0 0 1 2.25 0v4.594a1.126 1.126 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M16.125 20.875h3.75v-1.75h-3.75zM17.875 5.5c0-.111-.048-.306-.313-.58-.271-.28-.718-.585-1.356-.865-1.275-.557-3.115-.93-5.207-.93-2.09 0-3.93.373-5.206.93-.638.28-1.085.584-1.356.864-.265.275-.312.47-.312.581s.046.306.312.581c.271.28.718.583 1.356.863 1.275.558 3.115.931 5.206.931s3.932-.373 5.207-.931c.638-.28 1.085-.583 1.356-.863.266-.275.313-.47.313-.581m.75 10.25a.626.626 0 0 0-1.25 0v1.125h1.25zm2.25 1.314A2.12 2.12 0 0 1 22.125 19v2A2.125 2.125 0 0 1 20 23.125h-4A2.125 2.125 0 0 1 13.875 21v-2c0-.862.513-1.602 1.25-1.936v-1.313a2.876 2.876 0 0 1 5.75 0zM20.125 5.5c0 .855-.4 1.582-.944 2.144-.539.557-1.265 1.007-2.073 1.36-1.62.71-3.782 1.122-6.109 1.122s-4.486-.412-6.106-1.121c-.81-.354-1.535-.804-2.073-1.361-.544-.562-.945-1.289-.945-2.144s.401-1.583.945-2.145c.538-.557 1.264-1.007 2.073-1.36 1.62-.71 3.78-1.12 6.106-1.12s4.488.41 6.109 1.12c.808.353 1.534.803 2.073 1.36.543.562.944 1.29.944 2.145"
      />
    </svg>
  );
}
